
import { defineComponent, ref, computed } from "vue";
import { useStore } from "vuex";
export default defineComponent({
  name: "NavBar",
  setup() {
    const isOpen = ref<boolean>(false);
    const openMenu = ref<boolean>(false);
    const store = useStore();
    const isAuthenticated = computed(
      () => store.getters["auth/isAuthenticated"]
    );
    const currentUser = computed(() => store.getters["auth/user"]);

    const logout = async () => {
      await store.dispatch("auth/logout");
    };

    return { isOpen, openMenu, isAuthenticated, currentUser, logout };
  },
});
